var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6505 28.1154H26.8335V22.037C26.8335 20.5886 26.8043 18.731 24.8447 18.731C22.8558 18.731 22.5514 20.305 22.5514 21.9327V28.1146H18.7305V15.6299H22.3999V17.3324H22.4537C22.9634 16.3514 24.2119 15.3167 26.0724 15.3167C29.9425 15.3167 30.6551 17.9012 30.6551 21.2563V28.1146L30.6505 28.1154Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5078 15.6302H16.3333V28.115H12.5078V15.6302Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2051 11.6607C12.2051 10.421 13.1976 9.41513 14.4207 9.41513C15.6431 9.41513 16.6356 10.421 16.6364 11.6607C16.6364 12.9004 15.6439 13.9273 14.4207 13.9273C13.1976 13.9273 12.2051 12.9004 12.2051 11.6607Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.722656 20.0028C0.722656 8.98654 9.53418 0.0559082 20.4036 0.0559082C31.2678 0.0682373 40.0723 8.99173 40.0844 20.0028C40.0844 31.019 31.2729 39.9496 20.4036 39.9496C9.53418 39.9496 0.722656 31.019 0.722656 20.0028ZM2.03473 20.0028C2.03473 30.2846 10.2588 38.6198 20.4036 38.6198C30.5435 38.6081 38.7609 30.2797 38.7724 20.0028C38.7724 9.72092 30.5483 1.38571 20.4036 1.38571C10.2588 1.38571 2.03473 9.72092 2.03473 20.0028Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedin);
export default __webpack_public_path__ + "static/media/ic_linkedin.7b4a90e2.svg";
export { ForwardRef as ReactComponent };